export const ZONE_OPTIONS = ['54', '55'];
export const GNSS_SUITABILITY_OPTIONS = ['Good', 'Moderate', 'Poor'].map(
  (s) => ({
    name: s,
    value: s.toLowerCase(),
  }),
);

export enum SurveyMarkReportFormat {
  CSV_FILE = 'CSV file',
  KMZ_FILE = 'KMZ file',
}
